interface LocalizedMetadata {
  kieli: string;
  nimi: string;
}

export function getLocalizedName(
  metadata: LocalizedMetadata[] | undefined,
  locale: string
): string | undefined {
  if (!metadata?.length) return undefined;

  const lang = normalizeLang(locale);

  return (
    metadata.find(m => m.kieli === lang)?.nimi ||
    metadata.find(m => m.kieli === "FI")?.nimi ||
    metadata[0]?.nimi
  );
}

const normalizeLang = (locale: string): "FI" | "SV" | "EN" => {
  const normalized = locale.replace("_", "-").split("-")[0].toUpperCase();

  if (normalized === "FI" || normalized === "SV" || normalized === "EN") {
    return normalized;
  }

  return "FI"; // default fallback
};
